
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishcomment",
      function () {
        return require("private-next-pages/publishcomment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishcomment"])
      });
    }
  